import { observable,computed, action} from 'mobx';
import Transport from '../objects/transport';


export default class ReceptionTransportStore{

    @observable receptionTruck=[

    ];
    @observable receptionTrain;

    constructor(){
        this.receptionTruck = [
            // new Transport('wheat',19.2,19.2,10,10,30,'alert'),
            // new Transport('rape',20,16,10,10,50,'alert'),
            // new Transport('soy',19.2,19.2,10,10,50,'alert'),
            // new Transport('corn',19.2,19.2,10,10,50,'alert'),
            // new Transport('sunflower',19.2,19.2,10,10,50,'alert')
        ];
        this.receptionTrain=[
            // new Transport('wheat',60,60,5,7,50,'alert')
        ]
    }

    @computed get getTotalWheat(){
        return this.receptionTruck.reduce((prev, current)=>{return(current.culture === 'wheat' ? current.groupQuantity + prev : prev)},0)
    }
    @computed get getTotalSoy(){
        return this.receptionTruck.reduce((prev, current)=>{return(current.culture === 'soy' ? current.groupQuantity + prev : prev)},0)
    }
    @computed get getTotalRape(){
        return this.receptionTruck.reduce((prev, current)=>{return(current.culture === 'rape' ? current.groupQuantity + prev : prev)},0)
    }
    @computed get getTotalSunflower(){
        return this.receptionTruck.reduce((prev, current)=>{return(current.culture === 'sunflower' ? current.groupQuantity + prev : prev)},0)
    }
    @computed get getTotalCorn(){
        return this.receptionTruck.reduce((prev, current)=>{return(current.culture === 'corn' ? current.groupQuantity + prev : prev)},0)
    }

    @action removeTransport(id){
       this.receptionTruck.splice(id,1);
    }

    @action addTransport(transport){
        this.receptionTruck.push(transport);
    }


    // @action removeTransport(id,del,type){
    //     if (type === 'truck'){
    //         this.receptionTruck.splice(id, del);
    //     }else{
    //         this.receptionTrain.splice(id, del);
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/shared/stores/GameSessionStore/ReceptionTransportStore.js